import $ from 'jquery'

var breadcrumbsFlexible = function($element) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $breadcrumbsContainer,
      $slideLink,
      minHeight,
      maxHeight;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $breadcrumbsContainer = $('.flexible-row', $mainContainer);
    $slideLink = $('.flexible__breadcrumbs__sliding', $mainContainer);
    minHeight = $('.flexible-row li.last', $mainContainer).outerHeight();
    maxHeight = $('.flexible__breadcrumbs', $mainContainer).outerHeight();

    if (!SOPHIA.isIos()) {
      $breadcrumbsContainer.height(minHeight);
    }

    if ($('.flexible__breadcrumbs li').length < 2) {
      $slideLink.hide();
    }

    $breadcrumbsContainer.removeClass('active');
    $breadcrumbsContainer.height(minHeight);
    buildBreadcrumbs();

    bindDomEvents();
  }

  function bindDomEvents() {

    $(window).on('resize', function() {
      minHeight = $('.flexible-row li.last', $mainContainer).outerHeight();
      maxHeight = $('.flexible__breadcrumbs', $mainContainer).outerHeight();

      if (!SOPHIA.isIos()) {
        $breadcrumbsContainer.height(minHeight);
        $breadcrumbsContainer.removeClass('active');
      }

    });

    $(window).on('orientationchange', function() {
      minHeight = $('.flexible-row li.last', $mainContainer).outerHeight();

      $breadcrumbsContainer.height(minHeight);

      $breadcrumbsContainer.removeClass('active');
    });
  }

  function buildBreadcrumbs() {

    $slideLink.on('click', function(e) {
      e.preventDefault();

      if(!$breadcrumbsContainer.hasClass('active')) {
        $breadcrumbsContainer.animate({height: maxHeight}, 100, function(){
          $breadcrumbsContainer.addClass('active');
        });
      } else {
        $breadcrumbsContainer.removeClass('active');
        $breadcrumbsContainer.height(minHeight);
      }
    });
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
};

// jQuery plugin method
$.fn.breadcrumbsFlexible = function(options) {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('breadcrumbsFlexible')) {
      $this.data('breadcrumbsFlexible', breadcrumbsFlexible($this, options));
    }
  });
};
